/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   21/10/2022
 */

import { gql } from "urql";
import { ListResponse, OpsGenieEvent } from "../../interfaces/Global";

export const OpsGenieEventsQuery = gql`
    query OpsGenieEvents($schedules: [String!]!, $employees: [String!], $weeks: Int, $from: String) {
        opsGenieEvents(schedules: $schedules, employees: $employees, weeks: $weeks, from: $from) {
            total
            items {
                id
                typeId
	            capacityModifier
                employeeId
                startDatetime
                endDatetime
	            schedule {
		            id
		            name
                }
	            rotation {
		            id
		            name
                }
            }
        }
    }
`;

export interface OpsGenieEventsResponse {
	opsGenieEvents: ListResponse<OpsGenieEvent>
}

export interface OpsGenieEventsQueryVars {
	schedules: string[]
	employees?: string[]
	weeks?: number
	from?: string
}